import { useAuthStore } from '@/stores/auth'

/** Private query identity. Never persisted or included in performance logs. */
export function queryScope(): string {
  const auth = useAuthStore()
  return JSON.stringify([
    auth.session.authenticated, auth.session.user_id, auth.session.school_id,
    auth.permissions, auth.context,
  ])
}
